import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Comment } from '../db/Comment.js';

export const subscribeCommentsByReference = registerSubscription({
  type: () => [Comment],
  operationName: 'subscribeCommentsByReference',
  resolve: <T extends Comment = Comment>(referenceID: string) => {
    return (gqlFields: BaseQLSelectionSet<T>) => {
      return watchQuery<T>(Comment._collectionName, { relatedEntityID: referenceID });
    };
  },
  params: [{ name: 'referenceID', type: () => String }],
});
